import { Drawer, Grid2, IconButton, Typography } from "@mui/material";
import React, { ReactNode } from "react";
import { CloseIcon } from "./Icons";
import { Show } from "./Show";
import SimpleLoader from "./SimpleLoader";

interface GKSideModalProps {
  children: React.ReactNode;
  setOpen?: any;
  open: boolean;
  loading?: boolean;
  width?: any;
  modalTitle: string | ReactNode;
  footerButton?: any;
  onClose?: any;
  titleComponent?: any;
  subTitle?: any;
  disablePadding?: boolean;
}

const GKSideModal = (props: GKSideModalProps) => {
  const {
    children,
    setOpen,
    open,
    width,
    footerButton,
    titleComponent,
    modalTitle,
    onClose,
    loading,
    subTitle,
    disablePadding = false,
  } = props;
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose || (() => setOpen(false))}
      slotProps={{ paper: { sx: { width: width } } }}
    >
      <Grid2 container height={"100%"}>
        <Grid2
          p={1.5}
          size={12}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          borderBottom={"1px solid var(--neutral-100)"}
        >
          {typeof modalTitle === "string" ? (
            <Typography
              color={"var(--black)"}
              fontSize={18}
              fontWeight={700}
              whiteSpace={"nowrap"}
            >
              {modalTitle}
              {subTitle && (
                <Typography color={" #697586"} fontSize={12} fontWeight={500}>
                  {subTitle}
                </Typography>
              )}
            </Typography>
          ) : (
            modalTitle
          )}
          <span
            style={{
              display: "flex",
              gap: 10,
              alignItems: "center",
            }}
          >
            {titleComponent}
            <IconButton
              onClick={() => {
                if (onClose) {
                  onClose();
                }
                setOpen(false);
              }}
              sx={{
                borderRadius: 6,
                color: "var(--neutral-500)",
                background: "transparent",
                border: "none",
                "&:hover": {
                  color: "var(--neutral-500)",
                  background: "transparent",
                  border: "none",
                },
              }}
            >
              <CloseIcon width={20} height={20} />
            </IconButton>
          </span>
        </Grid2>

        <Grid2
          size={12}
          height={footerButton ? "calc(100vh - 127px)" : "calc(100vh - 61px)"}
          p={disablePadding ? 0 : 1.5}
          overflow={"auto"}
        >
          {loading ? <SimpleLoader /> : children}
        </Grid2>
        <Show.When isTrue={!!footerButton}>
          <Grid2
            size={12}
            p={1.5}
            style={{
              background: "var(--white)",
            }}
          >
            {footerButton}
          </Grid2>
        </Show.When>
      </Grid2>
    </Drawer>
  );
};

export default GKSideModal;
